import script from "./markdown.vue?vue&type=script&setup=true&lang=js"
export * from "./markdown.vue?vue&type=script&setup=true&lang=js"

import "./markdown.vue?vue&type=style&index=0&id=933293ca&scope=true&lang=css"

const __exports__ = script;

export default __exports__